/**
 * ReceivableStyles
 *
 * Styled components specific to receivable statements
 */

import styled from 'styled-components';

export const ClientNameInTitle = styled.div`
    font-weight: 700;
    font-size: 0.875rem;
    text-transform: uppercase;
    margin-bottom: 0.25rem;
    line-height: 1.2;
    word-break: break-word;
`;

export const Actions = styled.div`
    padding: 1rem;
    border-top: ${(props) => props.theme.DefaultBorder};
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .statement-action-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 1rem;
    }
`;

